import { MouseEvent } from 'react'
import { AdapterGenerico } from '../../Infraestructure/AdapterGenerico'
import './ElementInputFileAdjunto.scss'

interface PropsView {
  onChange: (fileList: LoadAdjunto[]) => any
  icon: string
  disabled?: boolean
  size?: number
  capture?: boolean
  multiple?: boolean
  allowedFormats: string[]
  paddingLeft?: string
  paddingRight?: string
  colorIcon?: string
  onClick?: (e: MouseEvent<HTMLInputElement>) => void
}

export interface ArchivosGrabar {
  File: File,
  Ruta: string,
}

export interface LoadAdjunto {
  NombreOriginal: string
  File: File
}

export const ElementInputFileAdjunto = (props: PropsView) => {

  const { allowedFormats, paddingLeft, paddingRight, colorIcon, onClick, capture } = props

  const isFormatValid = (fileList: FileList | null): any => {
    try {
      if (!fileList) return
      const adjuntos: LoadAdjunto[] = []
      let error = { isError: false, fileName: '' }
      Array.from(fileList).forEach((file, i) => {
        const ext = file.name.split('.').pop()?.toLowerCase()
        if (!allowedFormats.some(e => e.toUpperCase() === 'ALL')) {
          if (!ext || !allowedFormats.map(e => e.toLocaleLowerCase()).includes(ext)) {
            error = { isError: true, fileName: file.name }
          }
        }
        const nameTemp = file.name
        const [extAux] = nameTemp.split('.').reverse()
        const fileName = `${i}III${Math.floor(Date.now() / 1000)}.${extAux.toUpperCase()}`
        const adjunto = new File([file], fileName, {
          type: file.type,
          lastModified: file.lastModified
        })
        adjuntos.push({ NombreOriginal: nameTemp, File: adjunto })
      })

      if (error.isError) if (error.isError) throw new Error(`${error.fileName} no es un formato permitido`)

      props.onChange(adjuntos)
    } catch (error) {
      console.error(error)
      AdapterGenerico.createMessage('Alerta', (error as Error).message, 'warning', false)
    }
  }

  const imageExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'webp'];

  const onlyImages =
    allowedFormats.length > 0 &&
    allowedFormats.every(ext =>
      imageExtensions.includes(ext.toLowerCase())
    );

  const accept = capture
    ? 'image/*'
    : allowedFormats.some(e => e.toUpperCase() === 'ALL')
      ? ''
      : onlyImages
        ? 'image/*'
        : allowedFormats.map(ext => `.${ext}`).join(',')

  return (
    <label className='ElementInputFileAdjunto'>
      <input
        type='file'
        multiple={props.multiple}
        capture={capture ? true : undefined}
        accept={accept}
        onChange={(evt) => isFormatValid(evt.target.files)}
        disabled={props.disabled}
        value=''
        onClick={onClick}
      />
      <i
        className={props.icon}
        style={{
          fontSize: props.size || 30,
          paddingLeft: paddingLeft || '16px',
          paddingRight: paddingRight || '16px',
          color: colorIcon || 'inherit'
        }}
      />
    </label>
  )
}